import { useCallback, useRef } from 'react';

export type UseBroadcastMessageProps = {
  channelName: string;
  throttle?: number;
};

export const useBroadcastMessage = <T,>({ channelName, throttle }: UseBroadcastMessageProps) => {
  const channel = useRef(new BroadcastChannel(channelName)).current;
  const lastSentTimeRef = useRef<number>(0);

  const emitMessage = useCallback(
    (message: T) => {
      if (!throttle) {
        channel.postMessage(message);
        return;
      }

      const now = Date.now();
      if (now - lastSentTimeRef.current >= throttle) {
        channel.postMessage(message);
        lastSentTimeRef.current = now;
        return;
      }
    },
    [channel, throttle],
  );

  return { emitMessage };
};
